'use client';

import type { FilterOption } from '../../types/filter-option';
import type { TagFilterValue } from '../../types/filter-values';
import { SelectFilter } from './select-filter';

export type TagFilterProps = {
  readonly options: FilterOption[];
  readonly value: TagFilterValue | undefined;
  readonly onChange: (value: TagFilterValue | undefined) => void;
  readonly className?: string;
};

/**
 * TagFilter is a SelectFilter with color or emoji indicator support.
 * The indicator comes from FilterOption.color / FilterOption.emoji in column meta.
 */
export function TagFilter(props: TagFilterProps) {
  return <SelectFilter {...props} />;
}
